import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-static';

import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';
import LanguageSwitcherComponent from '../../components/LanguageSwitcher/LanguageSwitcher';
import { routePaths } from '../../../config/routePaths';

interface StateProps {
  language: Language;
}

interface LanguageSwitcherProps extends StateProps, RouteComponentProps<{}> {}

const LanguageSwitcher: React.SFC<LanguageSwitcherProps> = ({
  language,
  location: { pathname },
}) => {
  const addHrefToLanguages = () => {
    const pathnameWithSlash = pathname.replace(/^\/*/, '/');
    const currentLang = language;

    const foundPath = Object.values(routePaths).find(
      path => path[currentLang] === pathnameWithSlash,
    );

    const currentPathWithoutLang = pathnameWithSlash.replace(/^\/*cz\//, '/');
    return foundPath
      ? foundPath
      : {
          cz: `/cz${currentPathWithoutLang}`,
          en: currentPathWithoutLang,
        };
  };

  return <LanguageSwitcherComponent languages={addHrefToLanguages()} currentLanguage={language} />;
};

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withRouter(
  connect<StateProps, {}, {}, RootState>(mapStateToProps)(LanguageSwitcher),
);



// WEBPACK FOOTER //
// /www/client/src/containers/LanguageSwitcher/LanguageSwitcher.tsx